import { snakeToCamel } from '@mint-lib/api';

type Search = {
  mediaPlan?: string;
  activity?: string;
  flight?: string;
};

type ChosenLevel = {
  level: string;
  mediaDataId: string;
};

export const chooseLevel = (
  { level, mediaDataId }: ChosenLevel,
  search: Search,
): Search => ({
  mediaPlan: search.mediaPlan,
  [snakeToCamel(level)]: mediaDataId,
});
